export const iconFontAwesomeCampingTentArrowTurnLeft = (
	<i className="fa-solid fa-tent-arrow-turn-left"></i>
);
